module.exports = __webpack_public_path__ + "img/reward-7.2915f39f.svg";